import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsOptionCardComponent } from "./ds-option-card.component";
import { DsIconModule } from "../ds-icon/ds-icon.module";

@NgModule({
  declarations: [DsOptionCardComponent],
  imports: [CommonModule, DsIconModule],
  exports: [DsOptionCardComponent],
})
export class DsOptionCardModule {}
